import React, {useEffect, useReducer, useState} from "react";
import {DefaultButton, AlternativeButton, SmallButton} from "../widgets/Buttons";
import ModalPopup from "../widgets/ModalPopup";
import {useNavigate} from "react-router-dom";
import {Step} from "../widgets/Stepper";
import {Grid424} from "../widgets/Grids";
import Link from "../widgets/Link";
import {last} from "radash";
import {useApi} from "../ApiSession";
import DateInput from "../widgets/DateInput";
import {formatDate} from "../utils";





export const Grid22 = ({left, right}) =>
    <div className="flex flex-row pl-8 pr-8">
        <div className="basis-1/2">{left}</div>
        <div className="basis-1/2">{right}</div>
    </div>


const dataEntryRoundsOverviewReducer = (state, action) => {

    switch (action.name) {
        case "preInit": {
            return  {
                isReady: false
            }
        }
        case "init": {

            const currentRound = last(action.rounds)

            if (!currentRound) {
                debugger
            }

            return {
                isReady: true,
                rounds: action.rounds,
                currentRound,
                previousRounds: [...action.rounds].slice(0, -1),
                isFirstRound: action.rounds.length === 1,
                currentRoundIsNew: currentRound.observation_count === 0
            }
        }
        case "addNewRound": {

            return  {
                ...state,
                rounds: {id: action.id, visit_date: action.visit_date}
            }
        }
        default:
            throw new Error("Unknown action type " + action.name)
    }
}


export default ({healthOverviewDispatch, onCancel, dossierGuid}) => {

    const navigate  = useNavigate()

    const [newDataEntry, setNewDataEntry] = useState(null)

    const [newDataEntryWasCreated, setNewDataEntryWasCreated] = useState(false)

    const [dataEntryRoundsOverviewView, dataEntryRoundsOverviewViewDispatch] = useReducer(
        dataEntryRoundsOverviewReducer, dataEntryRoundsOverviewReducer(null, {name: 'preInit'})
    )

    const api = useApi()

    useEffect(() => {
        api.getRounds(dossierGuid).then(rounds => {
            dataEntryRoundsOverviewViewDispatch({name: "init", rounds})
        })
    }, [])

    if(! dataEntryRoundsOverviewView.isReady) {
        return <span>loading...</span>
    }

    if(newDataEntryWasCreated) {
        return <PopNewRoundCreated startQuestionnaire={() => {
            navigate(`/dossiers/${dossierGuid}`)
        }}/>
    }

    if(newDataEntry) {
        return <PopNewRound
            newDataEntry={newDataEntry}
            onCancel={() => setNewDataEntry(null)}
            lastRound={dataEntryRoundsOverviewView.currentRound}
            onCreateNew={(visit_date) => {

                api.newRound(dossierGuid, visit_date).then(res => {
                    dataEntryRoundsOverviewViewDispatch({
                        name: "addNewRound",
                        id: res.id,
                        visit_date
                    })
                })

                setNewDataEntry(null)
                setNewDataEntryWasCreated(true)
            }}
        />
    }


    return <ModalPopup
        title={"Vue d'ensemble des saisies du questionnaire"}
        onClose={onCancel}
        footer={
            <div className={"inline-flex items-center justify-center"}>

                <DefaultButton
                    caption={
                        dataEntryRoundsOverviewView.currentRoundIsNew ?
                            `Débuter la première saisie du questionaire` :
                            `Poursuivre la ${dataEntryRoundsOverviewView.rounds.length}e saisie du questionnaire`
                    }
                    onClick={
                        () => {
                            navigate(`/dossiers/${dossierGuid}`)
                        }
                    }
                />
                <span style={{marginLeft: 10}}/>
                {
                    (!dataEntryRoundsOverviewView.currentRoundIsNew) && <DefaultButton
                        caption={`Créer une nouvelle saisie du questionnaire`}
                        onClick={
                            () => {
                                setNewDataEntry({})
                            }
                        }
                    />
                }
                <AlternativeButton
                    caption={"Fermer"}
                    onClick={onCancel}
                />
            </div>
        }
    >
        <Grid22
            left={
                <ol className="relative text-gray-500 border-s border-gray-200 dark:border-gray-700 dark:text-gray-400">
                    {
                        dataEntryRoundsOverviewView.previousRounds.map((v, idx) =>
                            <Step
                                key={`k-${idx}`}
                                title={`${idx+1}e saisie du questionnaire`}
                                isCompleted={true}
                                details={
                                    <span>Visite du {v.visit_date}</span>
                                }
                            />
                        )
                    }
                    <Step
                        isCompleted={false}
                        title={`${dataEntryRoundsOverviewView.rounds.length}e saisie du questionnaire`}
                        details={
                            <span>
                                <b>Saisie du {dataEntryRoundsOverviewView.currentRound.visit_date}</b><br/>

                                {

                                    dataEntryRoundsOverviewView.currentRoundIsNew ?
                                        <span>
                                            <Link caption={"débuter la saisie"} href={`/dossiers/${dossierGuid}`}/>
                                        </span>
                                        :
                                        <span>
                                            Saisie en cours <Link caption={"poursuivre la saisie"} href={`/dossiers/${dossierGuid}`}/>
                                        </span>
                                }
                                <br/>
                                {
                                    (!dataEntryRoundsOverviewView.currentRoundIsNew) && <>
                                        Si la saisie est complétée, vous pouvez
                                        <Link onClick={()=> setNewDataEntry({})} caption={" créer une nouvelle saisie"}/>.
                                    </>
                                }
                            </span>
                        }
                    />
                </ol>
            }

            right={<div>
                <p className="text-gray-500 dark:text-gray-400">
                    Le questionnaire du registre vasculite permet de récolter des données sur le moyen et long terme.
                    Le questionnaire doit donc être saisie lors de la première visite, et re saisie à chaque nouvelle visite.
                </p>
            </div>}

        >

        </Grid22>

    </ModalPopup>
}


const PopNewRound = ({onCancel, onCreateNew, lastRound}) => {

    const [visitDate, setVisitDate] = useState(null);

    const [errorMsg, setErrorMsg] = useState('')

    useEffect(() => {
        const now = formatDate(new Date())

        if(visitDate > now) {
            setErrorMsg("ne peut être une date future")
        }
    }, [visitDate])

    return <ModalPopup
        title={"Créer une nouvelle Saisie du questionnaire"}
        onClose={onCancel}
        footer={
            <div className={"inline-flex items-center justify-center"}>
            <DefaultButton
                   caption={"Créer la nouvelle saisie"}
                   onClick={() => {
                       if(!errorMsg) {
                           onCreateNew(visitDate)
                       }
                   }}
                   isDisabled={errorMsg}
               />
                <AlternativeButton
                    caption={"Annuler"}
                    onClick={onCancel}
                />
            </div>
        }
    >

       <Grid424>
           <p>
               Une saisie du questionnaire se fait généralement suite à une visite du patient, veuillez saisir la date de visite.
           </p>
           {errorMsg  &&<p className="mt-2 text-sm text-red-600 dark:text-red-500">{errorMsg}</p>}
           <DateInput
               value={visitDate}
               adata={{fieldName: "visit_date"}}
               onFieldEdit={(fieldName, value) => {
                   setVisitDate(value)
                   if(lastRound.visit_date >= value) {
                       setErrorMsg(`doit succéder la dernière date de visite ${lastRound.visit_date}`)
                   }
                   else {
                       setErrorMsg(null)
                   }
               }}
           />
       </Grid424>
   </ModalPopup>
}


const PopNewRoundCreated = ({startQuestionnaire}) => {

   return <ModalPopup
        title={"Nouvelle saisie du questionnaire créée"}
        footer={
            <div className={"inline-flex items-center justify-center"}>
               <DefaultButton
                   caption={"Débuter la nouvelle saisie"}
                   onClick={startQuestionnaire}
               />
            </div>
        }
    >

       <Grid424>
           <p>
               Vous pouvez maintenant débuter la saisie du questionnaire.
           </p>
       </Grid424>
   </ModalPopup>
}